import { DeliveryIcon, ReturnsInfoIcon } from "assets/icons";
import { t } from "i18next";
import { Controller, FieldPath } from "react-hook-form";
import { FormField, Icon, Input, ReachTextEditor } from "ui";

import {
  InfoBarDataFormColumnProps,
  InfoBarDataFormValues
} from "../InfoBarDataForm.types";

import styles from "../InfoBarDataForm.module.scss";

const InfoBarDataFormColumn = ({
  control,
  columnType
}: InfoBarDataFormColumnProps) => {
  const headerName: FieldPath<InfoBarDataFormValues> = `${columnType}.header`;
  const descriptionName: FieldPath<InfoBarDataFormValues> = `${columnType}.description`;
  const contentName: FieldPath<InfoBarDataFormValues> = `${columnType}.content`;

  const labelIcon =
    columnType === "shippingData" ? DeliveryIcon : ReturnsInfoIcon;

  const labelText =
    columnType === "shippingData" ? "Shipping Info" : "Returns Info";

  return (
    <FormField
      containerClassName={styles.form_column}
      label={
        <div className={styles.form_column_label}>
          <Icon as={labelIcon} width={26} height={26} />
          <span>{t(labelText)}</span>
        </div>
      }
    >
      <Controller
        control={control}
        name={headerName}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <Input
            value={value}
            onChange={onChange}
            label={"Title"}
            placeholder={"Enter title"}
            errorMessage={error?.message}
          />
        )}
      />

      <Controller
        control={control}
        name={descriptionName}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <Input
            value={value}
            onChange={onChange}
            label={"Description"}
            placeholder={"Enter Description"}
            errorMessage={error?.message}
          />
        )}
      />

      <Controller
        control={control}
        name={contentName}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <ReachTextEditor
            defaultValue={value}
            label="Content"
            errorMessage={error?.message}
            onChange={(nextValue) => {
              onChange(nextValue || null);
            }}
          />
        )}
      />
    </FormField>
  );
};

export default InfoBarDataFormColumn;
